module.exports = "<button type=\"button\" seedelement class=\"lui-interactive\">\r\n  <svg class=\"lui-clear__icon\" viewBox=\"0 0 16 16\" version=\"1.1\">\r\n    <title>Clear</title>\r\n    <path\r\n      d=\"M12.59,14,8,9.39,3.41,14,2,12.54,6.56,8,2,3.41,3.41,2,8,6.56,12.54,2,14,3.41,9.39,8,14,12.59Z\"\r\n      style=\"fill: var(--lui-clear-color, var(--lui-subdued-text-color))\"\r\n    />\r\n  </svg>\r\n</button>\r\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-clear/theme/lui-clear.html
// module id = 194
// module chunks = 0 1 35